"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormControl_1 = __importDefault(require("../FormControl"));
var InputLabel_1 = __importDefault(require("../InputLabel"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var styles_1 = require("@mui/material/styles");
var colors_1 = require("../ThemeProvider/colors");
var prism_icons_1 = require("@octanner/prism-icons");
var __1 = require("..");
var utils_1 = require("./utils");
var StyledSelect = (0, styles_1.styled)(Select_1.default, { name: 'PrismSelect' })(function (_a) {
    var theme = _a.theme, label = _a.label, height = _a.height, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b;
    var actualHeight = (0, utils_1.getHeight)(height, label);
    var _c = inputProps.readOnly, readOnly = _c === void 0 ? false : _c;
    var iconSize = readOnly ? 12 : 18;
    return __assign({ height: actualHeight === 'short' ? 40 : 56, lineHeight: 'unset', backgroundColor: '#fff', border: "1px solid ".concat(colors_1.tannerGray['500']), borderRadius: 3, transition: theme.transitions.create(['border-color', 'box-shadow']), '&:hover': {
            backgroundColor: '#fff',
            borderColor: colors_1.tannerBlack,
        }, '&:active': {
            borderColor: colors_1.tannerGray['500'],
            backgroundColor: '#fff',
        }, '&.Mui-focused': {
            backgroundColor: '#fff',
        }, '& .MuiSelect-select': __assign(__assign({}, (label
            ? {
                padding: "27px 28px 10px 16px",
            }
            : {
                paddingTop: 0,
                paddingBottom: 0,
                alignItems: 'center',
                display: 'flex',
            })), (readOnly && {
            borderRadius: 3,
            backgroundColor: '#fff',
        })), '& .MuiSelect-root': {
            borderRadius: 3,
            marginRight: 0,
            '&:focus-visible': {
                backgroundColor: '#fff',
            },
        }, '& .MuiSelect-icon': {
            color: readOnly ? colors_1.tannerGray['400'] : 'currentColor',
            fontSize: 12,
            top: 'calc(50% - 9px)',
            transition: 'transform 200ms',
            right: 12,
            marginRight: readOnly ? 4 : 2,
            width: iconSize,
            height: iconSize,
            marginTop: readOnly ? 3 : 0,
        }, '&.Mui-disabled': {
            backgroundColor: colors_1.tannerGray['50'],
            color: colors_1.tannerGray['400'],
            '&:hover': {
                backgroundColor: colors_1.tannerGray['50'],
            },
        }, '&.Mui-error': {
            borderColor: colors_1.tannerSemantic.error.color,
        }, '&.MuiInputBase-root': {
            paddingRight: 0,
            '&.hover': {
                border: "1px solid ".concat(colors_1.tannerGray[readOnly ? 200 : 300]),
            },
        } }, (readOnly && {
        pointerEvents: 'none',
    }));
});
var Select = function (_a) {
    var children = _a.children, disabled = _a.disabled, fullWidth = _a.fullWidth, helperText = _a.helperText, error = _a.error, id = _a.id, label = _a.label, formControlProps = _a.formControlProps, inputProps = _a.inputProps, props = __rest(_a, ["children", "disabled", "fullWidth", "helperText", "error", "id", "label", "formControlProps", "inputProps"]);
    return (react_1.default.createElement(FormControl_1.default, __assign({ variant: "filled", disabled: disabled, fullWidth: fullWidth, error: error }, formControlProps, { sx: __assign({ minWidth: 176 }, formControlProps === null || formControlProps === void 0 ? void 0 : formControlProps.sx) }),
        label && react_1.default.createElement(InputLabel_1.default, { htmlFor: id }, label),
        react_1.default.createElement(StyledSelect, __assign({ IconComponent: (inputProps === null || inputProps === void 0 ? void 0 : inputProps.readOnly) ? prism_icons_1.Lock : prism_icons_1.ArrowDown, label: label, MenuProps: {
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { horizontal: 'left', vertical: 'top' },
            } }, props, { inputProps: __assign(__assign({}, inputProps), { id: id }) }), react_1.default.Children.toArray(children).map(function (child) {
            return react_1.default.isValidElement(child)
                ? react_1.default.cloneElement(child, {
                    // TODO figure out a way to remove this ts-ignore
                    // @ts-ignore this is an option and does have variant prop available
                    variant: !props.multiple ? 'check' : 'normal',
                    'aria-label': props.value === child.props.value
                        ? "".concat(child.props.children, " selected")
                        : child.props.children,
                })
                : child;
        })),
        helperText && react_1.default.createElement(__1.FormHelperText, null, helperText)));
};
exports.default = Select;
//# sourceMappingURL=index.js.map